import get from 'lodash/get'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import RatingStars from '../../../../helpers/RatingStars'
import Card from '../shared/Card'
import styles from './ProductTitleCard.module.scss'

ProductTitleCard.propTypes = {
  order: PropTypes.shape({
    shopTitle: PropTypes.string,
    rate: PropTypes.number,
    numberOfReviews: PropTypes.number,
    thumbnails: PropTypes.shape({
      DOSliderMobileLand: PropTypes.string,
    }),
  }).isRequired,
  url: PropTypes.string,
}

export default function ProductTitleCard({ order, url }) {
  const imgUrl = get(order, 'thumbnails.DOSliderMobileLand')
  const { shopTitle, rate, numberOfReviews } = order

  const reviewsLabel = (
    <FormattedMessage
      id='n_reviews'
      defaultMessage='{count} Reviews'
      values={{ count: numberOfReviews }}
    />
  )

  return (
    <Card className={styles.card}>
      {imgUrl && <img src={imgUrl} alt={shopTitle} className={styles.image} />}
      <h1 className={styles.title}>
        {url ? (
          <a
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            className={styles.titleLink}
          >
            {shopTitle}
          </a>
        ) : (
          shopTitle
        )}
      </h1>
      {numberOfReviews > 0 && (
        <div className={styles.ratingWrap}>
          <RatingStars rating={rate} />
          <span className={styles.reviewCount}>{reviewsLabel}</span>
        </div>
      )}
    </Card>
  )
}
